import styled from 'styled-components'

export const PlaylistWidgetContainer = styled.div`
    background-color: ${p => p.theme.footerBackgroundColor};
    padding: 0px;
    display: flex;
    flex-direction: column;
    height: 100vh;
`
